import { types } from 'mobx-state-tree'

const ChangePasswordCommand = types.model('ChangePasswordCommand', {
  userId: types.string,
  password: types.string,
  confirmPassword: types.string,
})

export default ChangePasswordCommand
